import type {Property} from '@deviceinsight/ng-ui-api-client';
import type {InfoWidgetProperty} from '../../types';
import {TFunction} from '@deviceinsight/ng-ui-scale-lib/api';

type PropertyConfigProps = {
	item: InfoWidgetProperty;
	assetProperties: Array<Property>;
	onPropertyChange: (arg0: React.ChangeEvent<HTMLSelectElement>) => void;
	t: TFunction;
};

const PropertyConfig = ({item, assetProperties, onPropertyChange, t}: PropertyConfigProps) => {
	const {propertyKey} = item;
	const defaultOption = t('dashboard.widget.info.property.select', {
		defaultValue: 'Please select...'
	});
	return (
		<td className="property-selector">
			<select onChange={onPropertyChange} value={propertyKey}>
				<option value="">{defaultOption}</option>
				{assetProperties.map((property, index) => (
					<option key={index} value={property.key}>
						{property.key}
					</option>
				))}
			</select>
		</td>
	);
};

export default PropertyConfig;
